import React from 'react';

import { connectSearchBox } from 'react-instantsearch-dom';

import { SearchInput } from '../SearchInput';

const ExpertsSearch = ({ refine, wrapperClass = '', handleClear }) => {
  return (
    <SearchInput handleSearch={refine} wrapperClass={wrapperClass} handleClear={handleClear} />
  );
};

export default connectSearchBox(ExpertsSearch);
